<template>
  <qc-container title="导出列表" >
    <search-box @reset-search="baseResetSearch" @action="loadData" v-model="searchObj.taskName" placeholder="请输入任务名称搜索">
      <template  #form-item>
        <el-form-item label-width="120px">
          <label class="labelName">状态</label>
          <simple-dict dict-type="reportTaskState" v-model="searchObj.state"></simple-dict>
        </el-form-item>
        <el-form-item label-width="120px">
          <label class="labelName">文件名</label>
          <el-input style="width:260px" v-model="searchObj.fileName" placeholder="文件名" ></el-input>
        </el-form-item>
      </template>
      <t-button  v-premission="'deleteReport'" @click="batchDelete()">删除</t-button>
    </search-box>
    <el-table :data="tableData" style="width: 100%"  border stripe v-loading="loading"
              @selection-change="selectionBaseChange"  element-loading-text="拼命加载中">
      <el-table-column label="任务名称" prop="taskName" width="180"></el-table-column>
      <el-table-column label="文件名" prop="fileName" ></el-table-column>
      <el-table-column label="状态" prop="stateDesc" width="180">
        <template v-slot="props">
          <span :class="props.row.status===-1?'red':''">{{props.row.stateDesc}}</span>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="createTime" width="180"></el-table-column>
<!--      <el-table-column type="expand">
        <template v-slot="props">
          <el-form label-position="left" inline class="demo-table-expand">
            <el-form-item label="任务名称">
              <span>{{ props.row.taskName }}</span>
            </el-form-item>
            <el-form-item label="文件名">
              <span>{{ props.row.fileName }}</span>
            </el-form-item>
            <el-form-item label="状态">
              <span>{{ props.row.stateDesc }}</span>
            </el-form-item>
            <el-form-item label="文件大小">
              <span>{{ props.row.fileSize }}</span>
            </el-form-item>
            <el-form-item label="执行时间">
              <span>{{ props.row.time }}</span>
            </el-form-item>
            <el-form-item label="执行结果">
              <span v-if="props.row.state==-1" class="red">{{ props.row.result }}</span>
              <span v-else="" class="green">{{ props.row.result }}</span>
            </el-form-item>
            &lt;!&ndash;<el-form-item label="任务参数" class="">
              <span>{{ props.row.taskParam }}</span>
            </el-form-item>&ndash;&gt;
          </el-form>
        </template>
      </el-table-column>-->
      <el-table-column label="操作">
        <template v-slot="scope">
          <el-button-group class="qc-table-group">
            <b-button type-class="mr10" v-premission="'resetReport'" v-if="scope.row.state==-1" @click="reExport(scope.row.id)" >重新导出</b-button>
            <download v-show="scope.row.fileUrl" :data="{path:filePath+scope.row.fileUrl,fileName:filterFileName(scope.row.fileName)}">
              <b-button>下载文件</b-button>
            </download>
            <b-button v-premission="'deleteReport'" type-class="red mr10" @click="doDel([scope.row.id])">删除</b-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <page ref="page" @handle-page="handlePage"></page>
  </qc-container>>
</template>

<script>
  import SimpleDict from "@/components/dict/SimpleDict";
  import Page from "@/components/base/page";
  import SearchBox from "@/components/base/SearchBox";
  import Download from '@/components/upload/download'
  import QcContainer from "@/components/el/layout/qc-container";
  import TButton from "@/components/el/t-button";
  import BButton from "@/components/el/b-button";
  export default {
    name: "report-list",
    components: {BButton, TButton, QcContainer, Download, SearchBox, Page, SimpleDict},
    data() {
      return {
        loading: false,
        selectItems:[],
        searchObj: {taskName:'',state:'',fileName:''},
        tableData: [],
      }
    },
    mixins: [tableBase],
    methods: {
      loadData(){
        this.loadPageData(Api.report+"list");
      },
      batchDelete(){
        var ids = this.getItems("id");
        this.deleteConfirm(Api.report+"/batchDelete",{ids:ids},result=>{
          this.loadData();
        });
      },
      doDel(ids){
        this.msgConfirm(Api.report+"/batchDelete",{ids:ids},result=>{
          this.loadData();
        });
      },
      reExport(id){
        this.msgConfirm(Api.report+"/resetReport",{ids:[id]},result=>{
          this.loadData();
        },"确定重新导出吗？");

      },
      filterFileName(fileName){
        if(fileName.indexOf(".")>=0){
          return fileName;
        }else{
          return fileName +'.xls';
        }
      }
    },
    mounted() {
      this.loadData();
      this.timer = setInterval(()=>{
        this.loadData();
      },3000)
    },
    unmounted(){
      clearInterval(this.timer);
      this.timer = null;
    }
  }
</script>


<style lang="less" scoped>
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
</style>
